import axios from "axios"
import { API_URL } from "./data"

let TOKEN = null;
try {
  const persistRoot = localStorage.getItem("persist:root");
  if (persistRoot) {
    const user = JSON.parse(JSON.parse(persistRoot).user);
    TOKEN = user?.currentUser?.accessToken || null;
  }
} catch (error) {
  console.error("Erreur lors de l'extraction du token utilisateur :", error);
}

export const publicRequest = axios.create({
    baseURL: API_URL
})

export const userRequest = axios.create({
    baseURL: API_URL,
    headers: { token: `Bearer ${TOKEN}` }
})